<template>
  <v-layout class="booking-client">
    <BookingAvatar :photo-url="photo_url" :color-id="color_id"/>
    <span class="client-name">{{full_name}}</span>
    <span v-if="shouldDisplayMatter" class="matter-name">{{matter.name}}</span>
  </v-layout>
</template>

<script>
  import BookingAvatar from "../bookingAvatar/BookingAvatar";
  export default {
    name: "BookingClient",
    components: {BookingAvatar},
    props: {
      full_name: {
        type: String,
        required: true,
      },
      color_id: {
        type: Number,
        required: true,
        validator: prop => prop === 9999 || (prop >= 0 && prop < 30)
      },
      photo_url: {
        type: String,
        required: false,
      },
      matter: {
        type: Object,
        required: false,
        validator: prop => prop.name,
      },
    },
    computed: {
      statusColor() {
        return this.color_id === 9999 ? 'color-current-staff' : `color_${this.color_id}`;
      },
      shouldDisplayMatter() {
        return this.matter && this.matter.name.trim() !== this.full_name.trim();
      },
    },
  };
</script>

<style lang="scss" scoped>

  .booking-client {
    align-items: center;
    font-family: var(--primary-font-family);
    font-stretch: normal;
    font-style: normal;

    .client-name {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: normal;
      color: #596671;
      padding: 0 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .matter-name {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: -0.33px;
      color: #0c1c28;
      line-height: 20px;
      border-left: 1px solid #dadce0;
      padding: 0 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

</style>
